<template>
	<JBox>
		<JBox class="s-w-full">
			<JBox class="s-mb-6">
				<CFormInput
					componentName="JSelect"
					:options="components"
					v-model="internalValue.component"
					name="component"
					label="Component to display"
					@input="internalValue.name = internalValue.component"
					@blur="$v.internalValue.component.$touch()"
				>
					<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.internalValue.component.$error"
						>This field is required</JText
					>
				</CFormInput>
				<JButton @click="isAddComponentVisible = true" variant="default-light-xs">+ Add new component</JButton>
			</JBox>

			<CFormInput
				componentName="JInputText"
				v-model="internalValue.path"
				name="path"
				class="s-mb-6"
				label="Path"
				@blur="$v.internalValue.path.$touch()"
			>
				<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.internalValue.path.$error">This field is required</JText>
			</CFormInput>

			<CFormInput
				componentName="JInputText"
				v-model="internalValue.name"
				name="name"
				class="s-mb-6"
				label="Page Name"
				@blur="
					internalValue.name = makePascalCase(internalValue.name)
					$v.internalValue.name.$touch()
				"
			>
				<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.internalValue.name.$error">This field is required</JText>
			</CFormInput>
		</JBox>

		<!-- Buttons -->
		<JFlex class="s-justify-between">
			<JBox>
				<JButton variant="default-light" @click="handleSubmit">Done</JButton>
				<JButton variant="white" class="s-ml-2" @click="$emit('cancel')">Cancel</JButton>
			</JBox>
			<JButton variant="error-light" @click="$emit('delete')">Delete Page</JButton>
		</JFlex>

		<!-- Create component modal -->
		<Portal to="layer3">
			<CModal variant="default-xs" :isVisible="isAddComponentVisible" @overlay:click="isAddComponentVisible = false">
				<JBox class="s-p-8">
					<ComponentCreateForm @cancel="isAddComponentVisible = false" @created="handleComponentCreated" />
				</JBox>
			</CModal>
		</Portal>
	</JBox>
</template>
<script>
import ComponentCreateForm from "./ComponentCreateForm"
import { required } from "vuelidate/lib/validators"
import camelCase from "lodash.camelcase"
import upperFirst from "lodash.upperfirst"

export default {
	components: { ComponentCreateForm },

	validations: {
		internalValue: {
			component: { required },
			path: { required },
			name: { required }
		}
	},

	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			internalValue: {},

			isAddComponentVisible: false
		}
	},

	computed: {
		components() {
			return [...(this.$store.state.uiEditor?.app?.components ?? [])]
				.reverse()
				?.map(item => ({ name: item.name, value: item.name }))
		}
	},

	methods: {
		makePascalCase(value) {
			return upperFirst(camelCase(value))
		},

		handleSubmit() {
			// Validate form
			this.$v.$touch()
			if (this.$v.$invalid) return

			this.$emit("update", this.internalValue)
		},

		handleComponentCreated({ name }) {
			console.log({ name })
			this.internalValue.component = name
			this.isAddComponentVisible = false
		}
	},

	watch: {
		value: {
			handler() {
				this.internalValue = { ...this.value }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
